import React from 'react'
import { render, unmountComponentAtNode } from 'react-dom'
import LiveModal from 'live/components/ui/Modal'
import ILTEditionAnnotationEventForm from './annotations/ilt/ILTEditionAnnotationEventForm'

interface Props {
    toggle: () => void,
    event: Object
}

function AnnotationModal({ toggle, event }: Props): JSX.Element {
    return (
        <LiveModal onHide={toggle} show={true}>
            <ILTEditionAnnotationEventForm event={event} onHide={toggle} />
        </LiveModal>
    )
}

export const openModal = function (event: Object): void {
    let modal = document.getElementById('__modal')
    if (!modal) {
        modal = document.createElement('div')
        modal.id = '__modal'
        document.body.appendChild(modal)
    }

    function toggle(): void {
        unmountComponentAtNode(modal)
        // console.log('toggle')
    }

    render(<AnnotationModal toggle={toggle} event={event} />, modal)
}
